module.exports = __webpack_public_path__ + "static/media/adminIcon05.188be04a.svg";